import React, { useState, useEffect } from 'react'
import Aos from 'aos';
import {
    Grid,
    Typography,
    Card,
    CardActionArea,
    CardContent
} from '@material-ui/core';
import CardMedia from "@material-ui/core/CardMedia";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    media: {
        position: "relative",
        paddingBottom: "22.25%",
        backgroundSize: "50%",
        marginBottom: '3rem'
    },
    topImageContainer: {
        minHeight: '40rem',
        marginTop: "3rem",
        paddingBottom: '5rem'
    },
    topImageContainerSmall: {
        minHeight: '100rem',
        marginTop: "1rem",
        paddingBottom: '2rem'
    },
    explanationBlock: {
        display: 'flex',
        paddingTop: '1rem',
        margin: '2rem 2rem 0rem 2rem ',
        '@media screen and (max-width: 900px)': {
            flexDirection: 'column'
        },
    },
    explanation: {
        height: '100%',
        lineHeight: '2.5rem',
        flex: 1,
        padding: '1rem',
        color: "#15678D",
        fontWeight: 200,
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: 20,
        '@media screen and (max-width: 1024px)': {
            fontSize: 20,
            lineHeight: '2rem',
        },
        '@media screen and (max-width: 700px)': {
            fontSize: 15,
            lineHeight: '2rem',
        },
    },
    icon: {
        fontSize: '3rem',
        margin: '1rem',
        color: '#15678D',
    },
    iconConsentForm: {
        fontSize: '3rem',
        margin: '1rem',
        color: '#15678D',
        textAlign: "center",
    },
    iconConsentFormSmall: {
        fontSize: '2rem',
        margin: '0.5rem',
        color: '#15678D',
        textAlign: "center",
    },
    iconSmall: {
        fontSize: '2rem',
        margin: '1rem',
        color: '#15678D',
        justifyContent: 'center'
    },
    impSpan: {
        fontWeight: 900
    },
    formStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '1rem'
    },
    documentItem: {
        textDecoration: 'none',
        color: "#15678D",
        alignSelf: 'start',
        fontSize: '1.5rem',
    },
    documentItemSmall: {
        textDecoration: 'none',
        color: "#15678D",
        alignSelf: 'start',
        fontSize: '1rem',
    },
    documentLine: {
        textAlign: 'start',
    },
    card: {
        backgroundColor: 'rgba(255,255,255,0.1)',
        color: '#15678D',
        textAlign: 'center',
        boxShadow: '0 3px 6px rgba(0,0,0,0.3)',
        height: '100%',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.03)',
        },
        textDecoration: 'none',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
            margin: '0 auto'
        }
    },
    cardContent: {
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1)
        }
    },
    cardTypography: {
        fontSize: '1rem',
        fontWeight: 'bold',
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.9rem'
        }
    },
    cardSubtitle: {
        fontSize: '0.9rem',
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.8rem'
        }
    }
}));

const AnnualReports = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const classes = useStyles();

    useEffect(() => {
        Aos.init({ duration: 3000 });
    }, []);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        }
    }, []);

    return (
        <div data-aos="fade-up" className={(windowWidth > 1024 ? classes.topImageContainer : classes.topImageContainerSmall)}>
            <Grid container spacing={0} alignItems="center" justifyContent="center">
                <Grid item xs={12} sm={12} md={10}>
                    <CardMedia>
                        <div className={classes.explanationBlock}>
                            <div data-aos="fade-up" className={(windowWidth > 1024 ? classes.icon : classes.iconSmall)}>
                                <i className="fas fa-user-tie"></i>
                            </div>
                            <div className={classes.explanation}>
                                At Blue Tulip Human Rights Center, we are committed to maintaining the highest standards of transparency and accountability. To demonstrate our dedication to these principles, we are pleased to share our Form 990 with our community.
                                <br /><br />
                                The Form 990 is an annual information return that most organizations exempt from income tax must file with the IRS. It provides detailed information about our mission, programs, and finances.
                                <br /><br />
                                You can view our latest Form 990 in the below links. Other years' data can also be accessed at IRS non-profit database.
                                <br /><br />
                                Thank you for your continued support and interest in Blue Tulip Human Rights Center.
                                <br /><br />
                                If you have any questions or need further information, please do not hesitate to contact us.
                            </div>
                        </div>
                    </CardMedia>
                </Grid>

                <Grid container spacing={3} justifyContent="center" style={{ marginTop: '1rem' }}>
                    {[2023, 2022, 2021, 2020, 2019, 2018, 2017].map((year) => (
                        <Grid item xs={8} sm={8} md={4} key={year}>
                            <a href={`/documents/${year}_Form990.pdf`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                <Card className={classes.card}>
                                    <CardActionArea>
                                        <CardContent className={classes.cardContent}>
                                            <Typography className={classes.cardTypography}>
                                                Form 990
                                            </Typography>
                                            <Typography className={classes.cardSubtitle}>
                                                Year {year}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </a>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </div>
    );
}

export default AnnualReports;
